import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useCart } from '../context/CartContext';

function Cart() {
  const { cartItems, removeFromCart, updateQuantity, getCartTotal } = useCart();
  const navigate = useNavigate();

  if (cartItems.length === 0) {
    return (
      <div className="cart-section">
        <Helmet>
          <title>Warenkorb - Lackfertighaus</title>
          <meta name="description" content="Ihr Warenkorb bei Lackfertighaus" />
          <link rel="canonical" href="https://lackfertighaus.com/cart" />
        </Helmet>
        
        <h1>Warenkorb</h1>
        <div className="cart-empty">
          <p>Ihr Warenkorb ist leer</p>
          <Link to="/" className="btn-primary">
            Weiter einkaufen
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-section">
      <Helmet>
        <title>Warenkorb - Lackfertighaus</title>
        <meta name="description" content="Ihr Warenkorb bei Lackfertighaus" />
        <link rel="canonical" href="https://lackfertighaus.com/cart" />
      </Helmet>

      <h1>Warenkorb</h1>

      <div className="cart-items">
        {cartItems.map(item => (
          <div key={item.id} className="cart-item">
            <img 
              src={item.image} 
              alt={item.name} 
              className="cart-item-image"
            />
            
            <div className="cart-item-info">
              <h3>{item.name}</h3>
              <p>{item.price.toFixed(2)} €</p>
            </div>

            <div className="cart-item-actions">
              <div className="quantity-controls">
                <button onClick={() => updateQuantity(item.id, item.quantity - 1)}>
                  -
                </button>
                <span>{item.quantity}</span>
                <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>
                  +
                </button>
              </div>
              <button 
                onClick={() => removeFromCart(item.id)}
                className="remove-btn"
              >
                Entfernen
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="cart-summary">
        <h2>Zusammenfassung</h2>
        <div className="cart-total">
          <span>Gesamtsumme:</span>
          <span>{getCartTotal().toFixed(2)} €</span>
        </div>
        <button 
          onClick={() => navigate('/checkout')}
          className="btn-primary"
          style={{ width: '100%' }}
        >
          Zur Kasse
        </button>
      </div>
    </div>
  );
}

export default Cart;